import React from "react";

const PerformanceInsights = ({
  totalTime = "00:00:00",
  answeringTime = "00:00:00",
  reviewingTime = "00:00:00",
  averageTime = "00:00:00",
  guessInsights = {},
}) => {
  const improvementFeedback = String(guessInsights?.improvementFeedback || "").trim();
  const positiveFeedback = String(guessInsights?.positiveFeedback || "").trim();
  const guessCount = Number(guessInsights?.guessCount || 0);
  const wrongGuessCount = Number(guessInsights?.wrongGuessCount || 0);
  const rightGuessCount = Number(guessInsights?.rightGuessCount || 0);

  const messageTitle = improvementFeedback
    ? "You need to improve your guess!"
    : positiveFeedback
      ? "Your guesses supported your score"
      : "Guess insights";

  const messageText = improvementFeedback || positiveFeedback || (
    guessCount > 0
      ? `${rightGuessCount} right guess and ${wrongGuessCount} wrong guess recorded.`
      : "No guess insights available for this attempt."
  );

  return (
    <>
      <section className="performance-insights">
        <h2>PERFORMANCE INSIGHTS</h2>

        <div className="insights-card">
          <div className="total-time">
            <strong>{totalTime}</strong>
            <span>Total Time Taken</span>
          </div>

          <div className="time-breakdown">
            <div className="time-item">
              <strong>{answeringTime}</strong>
              <span>Time for answering</span>
            </div>

            <div className="time-divider" />

            <div className="time-item">
              <strong>{reviewingTime}</strong>
              <span>Time for reviewing</span>
            </div>
          </div>

          <div className="average-time">
            Average time per answer: {averageTime}
          </div>
        </div>
      </section>

      <div className="performance-message">
        <div className="message-icon">
          <span className="bulb"><i className="fa-regular fa-lightbulb"></i></span>
        </div>

        <div className="message-content">
          <h3>{messageTitle}</h3>
          <p>{messageText}</p>
        </div>
      </div>
    </>
  );
};

export default PerformanceInsights;
